export default __webpack_public_path__ + "static/media/financial_services-lt.0b6d2b28.png";